(function($){
    function accordeonsToggle() {
        const buttons = document.querySelectorAll('.accordeon_button-js');

        buttons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();

                const parentLink = button.closest('.accordeon_link');

                // Si déjà actif → on le désactive
                if (parentLink.classList.contains('active')) {
                    parentLink.classList.remove('active');
                    return;
                }

                // Sinon → on désactive tous les autres
                document.querySelectorAll('.accordeon_link.active').forEach(link => {
                    link.classList.remove('active');
                });

                // Et on active celui cliqué
                parentLink.classList.add('active');
            });
        });
    };

    $(function() {
        accordeonsToggle();
    });
})(jQuery);
